import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Form } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Check } from 'lucide-react';
import { Package, PackagePrice } from 'models';
import services from 'services';
import PackageForm from 'components/forms/packages/PackageForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import './style.css';
var NewPackage = function (props) {
    var t = props.translate;
    var navigate = useNavigate();
    var newPackage = useState(function () {
        var pkg = new Package();
        pkg.setIsEnabled(true);
        return pkg;
    })[0];
    var newPackagePrice = useState(function () {
        var price = new PackagePrice();
        price.setQuantity(1);
        price.setPriceType('total_price');
        price.setIsEnabled(true);
        return price;
    })[0];
    var packageService = services.packageService;
    var _a = useState(false), disabled = _a[0], setDisabled = _a[1];
    var _b = packageService.useCreatePackage(), createPackage = _b.mutate, errorResponse = _b.isError;
    var packageEntities = packageService.useGetPackageEntities().data;
    var form = Form.useForm()[0];
    var syncModelsFromForm = function () {
        var _a, _b;
        var values = form.getFieldsValue(true);
        if (values.name != null)
            newPackage.setName(String(values.name).trim());
        if (values.packageElement != null) {
            newPackage.setEntityType(String(values.packageElement));
        }
        if (values.packageElementTitle != null && values.packageElementTitle !== '') {
            newPackage.setEntityId(Number(values.packageElementTitle));
        }
        if (values.description != null) {
            newPackage.setDescription(String(values.description));
        }
        var enabled = values.isEnabled !== false;
        newPackage.setIsEnabled(enabled);
        newPackagePrice.setIsEnabled(enabled);
        if (values.quantity != null && values.quantity !== '') {
            newPackagePrice.setQuantity(Number(values.quantity));
        }
        if (values.price != null && values.price !== '') {
            newPackagePrice.setPrice(Number(values.price));
        }
        if (values.priceType)
            newPackagePrice.setPriceType(String(values.priceType));
        if (values.unitMeasurement != null && values.unitMeasurement !== '') {
            var unitId = Number(values.unitMeasurement);
            newPackagePrice.setUnitMeasurementId(unitId);
            newPackage.setUnitMeasurementId(unitId);
        }
        var startedAt = values.startDate;
        if ((_a = startedAt === null || startedAt === void 0 ? void 0 : startedAt.isValid) === null || _a === void 0 ? void 0 : _a.call(startedAt)) {
            newPackagePrice.setStartedAt(startedAt.toDate());
        }
        var finishedAt = values.endDate;
        if ((_b = finishedAt === null || finishedAt === void 0 ? void 0 : finishedAt.isValid) === null || _b === void 0 ? void 0 : _b.call(finishedAt)) {
            newPackagePrice.setFinishedAt(finishedAt.toDate());
        }
    };
    var submit = function () {
        setDisabled(true);
        syncModelsFromForm();
        createPackage({
            newPackage: newPackage,
            newPackagePrice: newPackagePrice,
            successMessage: t('packageCreated'),
            packagePriceSuccessMessage: t('packagePriceCreated')
        });
    };
    useEffect(function () {
        if (errorResponse) {
            setDisabled(false);
        }
    }, [errorResponse]);
    var scrollToFirstElement = function () { return form.scrollToField('name', { behavior: 'smooth' }); };
    return (_jsxs("div", { className: "pkg-form-page", children: [_jsxs("header", { className: "pkg-form-page__header", children: [_jsxs("nav", { className: "pkg-form-page__breadcrumb", "aria-label": "Breadcrumb", children: [_jsx("span", { className: "pkg-form-page__crumb pkg-form-page__crumb--muted", children: t('breadcrumbCare') }), _jsx("span", { className: "pkg-form-page__sep", "aria-hidden": true, children: "/" }), _jsx(Link, { to: "/packages", className: "pkg-form-page__crumb", children: t('breadcrumbPackages') }), _jsx("span", { className: "pkg-form-page__sep", "aria-hidden": true, children: "/" }), _jsx("span", { className: "pkg-form-page__crumb pkg-form-page__crumb--current", children: t('breadcrumbNew') })] }), _jsxs("div", { className: "pkg-form-page__title-row", children: [_jsx("button", { type: "button", className: "pkg-form-page__back", onClick: function () { return navigate('/packages'); }, "aria-label": t('backToPackages'), title: t('backToPackages'), children: _jsx(ArrowLeft, { size: 20, strokeWidth: 2 }) }), _jsx("h1", { className: "pkg-form-page__title", children: t('title') })] })] }), _jsx("div", { className: "pkg-form-page__canvas", children: _jsxs(Form, { className: "pkg-form", layout: "vertical", form: form, initialValues: {
                        quantity: 1,
                        priceType: 'total_price',
                        isEnabled: true
                    }, onFinish: submit, onFinishFailed: scrollToFirstElement, requiredMark: false, children: [packageEntities ? (_jsx(PackageForm, { package: newPackage, packageEntities: packageEntities, packagePrice: newPackagePrice })) : null, _jsxs("div", { className: "pkg-form-page__footer", children: [_jsx("p", { className: "pkg-form-page__hint", children: t('requiredHint') }), _jsxs("div", { className: "pkg-form-page__footer-actions", children: [_jsx("button", { type: "button", className: "pkg-form-page__btn pkg-form-page__btn--ghost", onClick: function () { return navigate('/packages'); }, children: t('common:buttons.cancel') }), _jsxs("button", { type: "submit", className: "pkg-form-page__btn pkg-form-page__btn--primary", disabled: disabled || !packageEntities, children: [_jsx(Check, { size: 18, strokeWidth: 2 }), _jsx("span", { children: t('save') })] })] })] })] }) })] }));
};
export default localeTranslator(NewPackage, 'newPackage');
